import Image from '../../../components/AppImage';

const MessagePreview = ({ message }) => {
  const formatTimestamp = (date) => {
    const now = new Date();
    const msgDate = new Date(date);
    const diff = now - msgDate;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    if (days === 0) return 'Today';
    if (days === 1) return 'Yesterday';
    return msgDate?.toLocaleDateString('en-PH', { month: 'short', day: 'numeric' });
  };

  return (
    <div className="flex items-start gap-2 md:gap-3 p-2 md:p-3 rounded-md hover:bg-muted/50 transition-smooth cursor-pointer">
      <div className="relative flex-shrink-0">
        <Image
          src={message?.avatar}
          alt={message?.avatarAlt}
          className="w-8 h-8 md:w-10 md:h-10 rounded-full object-cover"
        />
        {message?.online && (
          <div className="absolute bottom-0 right-0 w-2 h-2 md:w-2.5 md:h-2.5 bg-success rounded-full border border-card" />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-0.5 md:mb-1">
          <p className="text-xs md:text-sm font-medium text-foreground line-clamp-1">
            {message?.name}
          </p>
          <p className="text-[10px] md:text-xs text-muted-foreground flex-shrink-0">
            {formatTimestamp(message?.timestamp)}
          </p>
        </div>
        <p className={`text-[10px] md:text-xs line-clamp-1 ${
          message?.unread ? 'text-foreground font-medium' : 'text-muted-foreground'
        }`}>
          {message?.preview}
        </p>
      </div>
      {message?.unread && (
        <div className="w-1.5 h-1.5 md:w-2 md:h-2 bg-primary rounded-full flex-shrink-0 mt-1.5 md:mt-2" />
      )}
    </div>
  );
};

export default MessagePreview;